import React from 'react'
import CtaButton from 'Src/components/Buttons/CtaButton'
import {usePageContext} from 'Src/components/pages/SoftPull/PageContext'
import Address from 'Src/components/SoftPull/Form/Address'
import CityCounty from 'Src/components/SoftPull/Form/CityCounty'
import EmailAddress from 'Src/components/SoftPull/Form/EmailAddress'
import Errors from 'Src/components/SoftPull/Form/Errors'
import FirstName from 'Src/components/SoftPull/Form/FirstName'
import LastName from 'Src/components/SoftPull/Form/LastName'
import LegalCheckbox from 'Src/components/SoftPull/Form/LegalCheckbox'
import PhoneNumber from 'Src/components/SoftPull/Form/PhoneNumber'
import State from 'Src/components/SoftPull/Form/State'
import ZipCode from 'Src/components/SoftPull/Form/ZipCode'
import {trans} from 'Src/utilities/Helpers'

const Form = () => {
  const {handleSubmit, onSubmit} = usePageContext()

  return (
    <div className="tw-mx-6 tw-p-2">
      <form name="register" id="register" onSubmit={handleSubmit(onSubmit)}>
        <Errors />
        <div className="tw-mb-6 tw-flex tw-flex-col tw-justify-between tw-gap-6 md:tw-flex-row">
          <FirstName />
          <LastName />
        </div>
        <Address />
        <div className="tw-mb-6 tw-flex tw-flex-col tw-justify-between tw-gap-6 md:tw-flex-row">
          <ZipCode />
          <CityCounty />
          <State />
        </div>
        <div className="tw-mb-6 tw-flex tw-flex-col tw-justify-between tw-gap-6 md:tw-flex-row">
          <EmailAddress />
          <PhoneNumber />
        </div>
        <LegalCheckbox />
        <div className="tw-mb-8 tw-flex tw-justify-center">
          <CtaButton type="submit" className="tw-w-80">
            {trans('Submit')}
          </CtaButton>
        </div>
      </form>
    </div>
  )
}

export default Form
